/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Opening_HoursInputs */

const vi_shop_contact_opening_hours = /** @type {(inputs: Shop_Contact_Opening_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ mở cửa`)
};

/**

* @param {Shop_Contact_Opening_HoursInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_opening_hours = /** @type {((inputs?: Shop_Contact_Opening_HoursInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Opening_HoursInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_opening_hours(inputs)
});